import { render, staticRenderFns } from "./violationList.vue?vue&type=template&id=898bce40&scoped=true"
import script from "./violationList.vue?vue&type=script&lang=js"
export * from "./violationList.vue?vue&type=script&lang=js"
import style0 from "./violationList.vue?vue&type=style&index=0&id=898bce40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898bce40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('898bce40')) {
      api.createRecord('898bce40', component.options)
    } else {
      api.reload('898bce40', component.options)
    }
    module.hot.accept("./violationList.vue?vue&type=template&id=898bce40&scoped=true", function () {
      api.rerender('898bce40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditList/exposal/violation/violationList.vue"
export default component.exports